// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__21ndc","fileBtn":"File_fileBtn__2YLu9","closeBtn":"File_closeBtn__1wrEK","fileSelected":"File_fileSelected__1-cWe","disabled":"File_disabled__MDJEb"};